import { Pipe, PipeTransform } from '@angular/core';
import { MomentHelperService, UTCOffset } from '@supoui/core/services/moment-helper.service';
import moment from 'moment';

@Pipe({
    name: 'momentFormat',
    standalone: false
})
export class MomentPipe implements PipeTransform {
  constructor() {}
  transform(value: moment.Moment | null, dateFormat: string, utcOffset: UTCOffset): string {
    utcOffset = MomentHelperService.resolveUtcOffset(utcOffset);
    return value ? value.utcOffset(utcOffset).format(dateFormat) : '';
  }
}
